module.exports = {
  __init__: [ 'defaultRenderer' ],
  defaultRenderer: [ 'type', require('./DefaultRenderer') ],
  styles: [ 'type', require('./Styles') ]
};



// WEBPACK FOOTER //
// ./~/diagram-js/lib/draw/index.js